export const GET_PRODUCTION_STRUMIS_PRODUCTION_DELIVERY_NOTES = "GET_PRODUCTION_STRUMIS_PRODUCTION_DELIVERY_NOTES";
export const getProductionStrumisProductionDeliveryNotes = () => {
  const url = "/production/strumis/delivery_notes/index.json";
  const request = axios.get(url);
  return {
    type: GET_PRODUCTION_STRUMIS_PRODUCTION_DELIVERY_NOTES,
    payload: request,
  };
};